// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__vX3he","content":"ManualTimeModal_content__2BDbZ"};